@if (!companyFailedToLoad) {
  <h1 class="content-main-title">{{ 'content.create-company' | translate }}</h1>
  <div class="d-flex justify-content-end">{{ 'content.all.required-field-explanation' | translate }}</div>
  <form [formGroup]="f" [ngClass]="{'form-submitted': formSubmitted}" (ngSubmit)="submit(f.value)">
    <h2>{{ 'content.company' | translate }}</h2>
    <div class="form-row">
      <div class="form-group col-md-4">
        <label>{{ 'content.company-name' | translate }} *
          <input class="form-control" type="text" autocomplete="on" formControlName="companyName" #companyNameInput>
        </label>
        <app-validation-errors [displayErrors]="formSubmitted" [errors]="c.companyName.errors" [element]="companyNameInput"></app-validation-errors>
      </div>
    </div>
    <div class="row">
      <div class="form-inline col-md-4">
        <input id="ipBypass" class="form-check-input ms-2 me-2" type="checkbox" formControlName="ipBypass">
        <label class="form-check-label col-md-10 ps-0" for="ipBypass">{{ 'content.ip-bypass' | translate }}</label>
      </div>
    </div>
    <div class="d-flex inline-gap-5">
      <button class="tu-button secondary tu-shadow ms-auto" type="button" routerLink="/admin/companies">{{ 'content.cancel' | translate }}</button>
      <button class="tu-button primary tu-shadow" type="submit">{{ 'content.save' | translate }}</button>
    </div>
  </form>
} @else {
  {{ 'content.company-not-found' | translate:{companyName: companyNameParam} }}
}
